import React from "react";

const DeliveryForm = ({ deliveryDetails, setDeliveryDetails }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDeliveryDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  return (
    <form className="delivery-form">
      <h3>Delivery Details</h3>
      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={deliveryDetails.name}
        onChange={handleInputChange}
        required
      />
      <input
        type="text"
        name="address"
        placeholder="Address"
        value={deliveryDetails.address}
        onChange={handleInputChange}
        required
      />
      <input
        type="text"
        name="city"
        placeholder="City"
        value={deliveryDetails.city}
        onChange={handleInputChange}
        required
      />
      <input
        type="text"
        name="postalCode"
        placeholder="Postal Code"
        value={deliveryDetails.postalCode}
        onChange={handleInputChange}
        required
      />
      <input
        type="text"
        name="phone"
        placeholder="Phone Number"
        value={deliveryDetails.phone}
        onChange={handleInputChange}
        required
      />
    </form>
  );
};

export default DeliveryForm;
